import { colors } from "component_library/styles/theme"
import { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"

export const autouncleProTheme: DealerTheme = {
  brandPrimary: colors.blue_500,
  inversePrimary: "",
} as const

export const autouncleBrandTheme: DealerTheme = {
  brandPrimary: colors.variant_600,
  inversePrimary: colors.white,
  secondaryFontFamily: "Poppins, sans-serif",
  buttonBorderRadius: "md",
} as const
